const SWYM_REMOVE_ICON_SVG = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2L15.09 8.58255L22 9.64458L17 14.7655L18.18 22L12 18.5825L5.82 22L7 14.7655L2 9.64458L8.91 8.58255L12 2Z" stroke="black" style="stroke:black;stroke-opacity:1" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

function buildWishlistCard(product) {
	const title = product.dt || '';
	const url = product.du || '';

	const item = document.createElement('div');
	item.className = 'swym-wishlist-item swym-is-anchor';

	const topLink = document.createElement('a');
	topLink.href = url;
	topLink.setAttribute('aria-label', title);

	const imageWrapper = document.createElement('div');
	imageWrapper.className = 'swym-wishlist-image-wrapper';
	const img = document.createElement('img');
	img.className = 'swym-wishlist-image';
	img.src = product.iu || '';
	img.alt = '';
	imageWrapper.appendChild(img);

	const removeBtn = document.createElement('button');
	removeBtn.className = 'swym-delete-btn swym-remove-productBtn swym-nav swym-nav-1 swym-is-button';
	removeBtn.setAttribute('aria-label', 'Remove ' + title + ' from wishlist');
	removeBtn.setAttribute('data-variant-id', product.epi);
	removeBtn.setAttribute('data-product-id', product.empi);
	removeBtn.innerHTML = SWYM_REMOVE_ICON_SVG;
	removeBtn.addEventListener('click', onRemoveBtnClick);

	topLink.appendChild(imageWrapper);
	topLink.appendChild(removeBtn);

	const content = document.createElement('div');

	const titleEl = document.createElement('div');
	titleEl.className = 'swym-title swym-title-1';
	titleEl.textContent = title;

	const priceWrap = document.createElement('div');
	priceWrap.className = 'swym-product-price swym-text swym-text-1';
	priceWrap.setAttribute('data-wishlist-price-handle', product.handle || '');
	priceWrap.setAttribute('aria-live', 'polite');
	const priceValue = document.createElement('div');
	priceValue.className = 'swym-product-final-price swym-value';
	priceWrap.appendChild(priceValue);

	const variantWrap = document.createElement('div');
	variantWrap.className = 'swym-variant-title swym-text swym-title-2 swym-variant-select';
	const sizeLabel = document.createElement('span');
	sizeLabel.className = 'variant-size-title';
	sizeLabel.textContent = 'Size';
	const select = document.createElement('select');
	select.className = 'variant-control drawer-atc-trigger';
	select.setAttribute('data-wishlist-product-handle', product.handle || '');
	select.setAttribute('aria-label', 'Size');
	variantWrap.appendChild(sizeLabel);
	variantWrap.appendChild(select);

	const atcBtn = document.createElement('button');
	atcBtn.className = 'account-drawer__cta-button atc-btn';
	atcBtn.setAttribute('data-product-url', url);
	atcBtn.setAttribute('data-variant-id', product.epi);
	atcBtn.setAttribute('data-product-id', product.empi);
	atcBtn.disabled = true;
	atcBtn.textContent = 'Add To Cart';

	content.appendChild(titleEl);
	content.appendChild(priceWrap);
	content.appendChild(variantWrap);
	content.appendChild(atcBtn);

	item.appendChild(topLink);
	item.appendChild(content);

	return item;
}

function renderWishlistVariantPrice(priceEl, variant) {
	if (variant.compare_at_price && variant.compare_at_price > variant.price) {
		priceEl.innerHTML = '<del>' + bassike.formatSwymPrice(variant.compare_at_price) + '</del> ' + bassike.formatSwymPrice(variant.price);
	} else {
		priceEl.textContent = bassike.formatSwymPrice(variant.price);
	}
}

window.__swymProductCache = window.__swymProductCache || {};

async function getProductData(handle) {
	if (window.__swymProductCache[handle]) return window.__swymProductCache[handle];
	var res = await fetch('/products/' + handle + '.js');
	if (!res.ok) throw new Error('Product fetch failed');
	var data = await res.json();
	window.__swymProductCache[handle] = data;
	return data;
}

async function renderSelects(product) {
  const selects = document.querySelectorAll(`[data-wishlist-product-handle="${product.handle}"]`);
  if (selects?.length && product) {
    let productData;
    try {
      productData = await getProductData(product.handle);
    } catch (e) {
      var priceContainers = document.querySelectorAll(`[data-wishlist-price-handle="${product.handle}"]`);
      priceContainers.forEach(function(container) {
        var priceEl = container.querySelector('.swym-product-final-price');
        if (priceEl && product.pr != null) {
          priceEl.textContent = bassike.formatSwymFallbackPrice(product.pr);
        }
      });
      return;
    }
    const variants = productData.variants || [];
    const savedVariantId = product.epi?.toString();

    // Update price display with local currency
    var savedVariant = variants.find(function(v) { return v.id.toString() === savedVariantId; });
    var displayVariant = savedVariant || variants.find(function(v) { return v.available; }) || variants[0];
    var priceContainers = document.querySelectorAll(`[data-wishlist-price-handle="${product.handle}"]`);
    priceContainers.forEach(function(container) {
      var priceEl = container.querySelector('.swym-product-final-price');
      if (priceEl && displayVariant) {
        renderWishlistVariantPrice(priceEl, displayVariant);
      }
    });

    const options = `
      <option value="">Select A Size</option>
      ${variants.map((v) => {
        if (v.available) {
          const selected = v.id.toString() === savedVariantId ? 'selected="selected"' : '';
          return `<option value="${v.id}" ${selected}>${v.title}</option>`;
        }
        return '';
      }).join('')}
    `;

    for (let i = 0; i < selects.length; i += 1) {
      const select = selects[i];
      select.innerHTML = options;

      const parent = select.closest('.swym-wishlist-item');
      const button = parent?.querySelector('button.atc-btn');

      if (savedVariantId && button) {
        button.dataset.variantId = savedVariantId;
        button.disabled = false;
      }

      select.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        if (button) {
          button.dataset.variantId = selectedValue;
          button.disabled = !selectedValue;
        }
        // Update price when variant changes
        var priceEl = parent?.querySelector('.swym-product-final-price');
        if (priceEl && selectedValue) {
          var selectedVariant = variants.find(function(v) { return v.id.toString() === selectedValue; });
          if (selectedVariant) {
            renderWishlistVariantPrice(priceEl, selectedVariant);
          }
        }
      });

      if (button && !button.__swymAtcBound) {
        button.__swymAtcBound = true;
        button.addEventListener('click', () => {
          const toast = document.querySelector('.toast-message');
          if (toast) toast.setAttribute('role', 'status');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: button.dataset.variantId, quantity: 1 }]
            })
          })
            .then(response => response.json())
            .then(() => {
              if (toast) {
                toast.innerHTML = `<p>Added to cart</p>`;
                toast.classList.add('active');
                setTimeout(() => toast.classList.remove('active'), 3000);
              }
              window.location.reload();
            })
            .catch(() => {
              if (toast) {
                toast.innerHTML = `<p>Unable to add to cart</p>`;
                toast.classList.add('active');
                setTimeout(() => toast.classList.remove('active'), 3000);
              }
            });
        });
      }
    }
  }
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	});
}

function swymRenderWishlist(swat) {
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.querySelectorAll(".wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p);
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			p.handle = p.du.split('/products/')[1]?.split('?')[0];
			return p;
		});
		if(wishlistContentsContainer.length){
			wishlistContentsContainer.forEach((container) => {
				container.innerHTML = '';
				const grid = document.createElement('div');
				grid.className = 'swym-wishlist-grid';
				formattedWishlistedProducts.forEach(function(p) {
					grid.appendChild(buildWishlistCard(p));
				});
				container.appendChild(grid);
     		});

			Promise.all(formattedWishlistedProducts.map(function(p) { return renderSelects(p); }));
		}
	});

	swat.fetchLists({
		callbackFn: (lists) => {
			const list = lists[0];
			const lid = lists[0].lid;
			window.SwymListId = lid;

			const wishlistWrapper = document.querySelector('.wishlist-card-wrapper');
			if (lists?.[0]?.listcontents?.length) {
				const emptyWrapper = document.querySelector('.wishlist-empty');
				if (emptyWrapper) {
					emptyWrapper.style.display = 'none';
				}
				if (wishlistWrapper) {
					const content = wishlistWrapper.querySelector('.account-drawer__item');
					if (content) {
						content.style.display = 'flex';
					}
					wishlistWrapper.classList.remove('wishlist-card-wrapper');
				}
			}

			const addToCartButtons = document.querySelectorAll("product-card .custom-add-to-wishlist-button");
			addToCartButtons.forEach((button) => {
				if(button) {
					button.addEventListener("click", (e) => {
						const target = e.currentTarget;
						const product = {
							empi: target.getAttribute("data-product-id"),
							epi: target.getAttribute("data-variant-id"),
							du: target.getAttribute("data-product-url")
						};
						const onSuccess = () => { swymRenderWishlist(swat); };
						const onError = () => {};
						swat.addToList(lid, product, onSuccess, onError);
					});
				}
			});

			updateButtonState(list);
		},
		errorFn: () => {}
	});
}

const updateButtonState = (list) => {
  const swymWishlistButtons = document.querySelectorAll('.custom-add-to-wishlist-button');
  if (!swymWishlistButtons) return;

  swymWishlistButtons.forEach((button) => {
    const productId = button.getAttribute('data-product-id');
    const variantId = button.getAttribute('data-variant-id');
    let isWishlisted = false;

    if (list && list.listcontents?.length) {
      list.listcontents.forEach(item => {
        if (item.empi == productId && item.epi == variantId) {
          isWishlisted = true;
        }
      });
    }

    updateButtonWishlistState(button, isWishlisted);
  });
};

const updateButtonWishlistState = (element, isWishlisted) => {
	if (isWishlisted) {
		element.classList.add('swym-added');
	} else {
		element.classList.remove('swym-added');
	}
};

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

function initializeSwym() {
    if (!window._swat) {
        setTimeout(initializeSwym, 1000);
        return;
    }
	const pdpEmptyIcon = document.querySelector(".pdp-empty-icon");
	if (pdpEmptyIcon) {
		pdpEmptyIcon.style.opacity = "0";
		setTimeout(() => {
			pdpEmptyIcon.style.opacity = "1";
		}, 800);
	}
    const swat = window._swat;
    swymRenderWishlist(swat);

    const toggleButtons = document.querySelectorAll('.toggle-wishlist');
    if (toggleButtons.length) {
        for (let i = 0; i < toggleButtons.length; i += 1) {
            const btn = toggleButtons[i];
            btn.addEventListener('click', (e) => {
                if (e.target.className.includes('swym-added')) {
                    onRemoveBtnClick(e);
                } else {
                    const product = {
                        epi: e.target.dataset.variantId,
                        empi: e.target.dataset.productId,
                        du: e.target.dataset.productUrl
                    };
                    swat.addToList(window.SwymListId, product, () => {
                        e.target.classList.add('swym-added');
                        if (e.target.className.includes('cart-line')) {
                            e.target.innerText = 'Added to wishlist';
                        }
						if (e.target.dataset.removeUrl) {
							fetch(e.target.dataset.removeUrl)
							.then(() => { window.location.reload(); })
							.catch(() => { window.location.reload(); });
						}
                        swymRenderWishlist(swat);
                    }, () => {});
                }
            });
        }
    }
}

window.SwymCallbacks.push(initializeSwym);

document.addEventListener('DOMContentLoaded', () => {
    initializeSwym();
});
